namespace Matrix.Data {
    export interface JpmSecClassOverrideRow {
        SecurityId?: string;
        MxInputSignature?: string;
        SecTypeCode?: string;
        Industry?: string;
        DaysToMaturity?: string;
        MaturityBand?: string;
        CountryOfExposure?: string;
        CurrencyOfExposure?: string;
        EmergingMarket?: string;
        AaSector?: string;
        CounterpartyOrIssuer?: string;
        CountryOfIssue?: string;
    }

    export namespace JpmSecClassOverrideRow {
        export const idProperty = 'SecurityId';
        export const nameProperty = 'SecurityId';
        export const localTextPrefix = 'Data.JpmSecClassOverride';
        export const deletePermission = 'DataAdmin:JPMSecClassOverride';
        export const insertPermission = 'DataAdmin:JPMSecClassOverride';
        export const readPermission = 'Read:JPMSecClassOverride';
        export const updatePermission = 'DataAdmin:JPMSecClassOverride';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            MxInputSignature = "MxInputSignature",
            SecTypeCode = "SecTypeCode",
            Industry = "Industry",
            DaysToMaturity = "DaysToMaturity",
            MaturityBand = "MaturityBand",
            CountryOfExposure = "CountryOfExposure",
            CurrencyOfExposure = "CurrencyOfExposure",
            EmergingMarket = "EmergingMarket",
            AaSector = "AaSector",
            CounterpartyOrIssuer = "CounterpartyOrIssuer",
            CountryOfIssue = "CountryOfIssue"
        }
    }
}
